import apiInstance from "./axiosBase";

export const HolidaysAPI = {
  bankHolidays: () => {
    return apiInstance.get("/holiday/bank");
  },
};
